/**
 * TODO: add api/web/v1/users/experiments/getTreatment to get the treatment for the user
 * then use the treatment to determine if the user can access flexible properties
 * then return the treatment to the component
 */
import accessUtils from '../utils/accessUtils';

export const useFlexiblePropertiesEntry = () => {
  const canAccessFlexibleProperties = accessUtils.canAccessFlexibleProperties();

  return { canAccessFlexibleProperties };
};
